<template>
  <div class="animated fadeIn"> 
    <b-card-body>
      <b-row>
        <b-col sm xs="12" class="text-left mt-3">
          <router-link to="/entites/create">
            <b-button variant="primary" style="width:103px;height:40px;border-radius:0px;">
              <i class="fa fa-plus"></i>&nbsp;Nouveaux
            </b-button>
          </router-link>
        </b-col>
      </b-row>
    </b-card-body>
    <b-row>
     <b-col lg="12">
        <b-alert v-for="(errors, id) in response.errors" :key="id" :show="dismissCountDown"
                  dismissible
                  :variant="response.success== true ? 'success':'danger'"
                  @dismissed="dismissCountdown=0"
                  @dismiss-count-down="countDownChanged">
            <p v-if="response.errors" style="font-size:13px;margin-bottom: 0;"><b>{{ id }}</b> : <span v-for="(error, index) in errors" :key="index"><br>{{ error }}</span></p>
           <strong v-if="!response.errors">{{response.message}}</strong>
        </b-alert>
        <b-alert v-if="!response.errors" :show="dismissCountDown"
                  dismissible
                  :variant="response.success== true ? 'success':'danger'"
                  @dismissed="dismissCountdown=0"
                  @dismiss-count-down="countDownChanged">
           <strong v-if="!response.errors">{{response.message}}</strong>
        </b-alert>
        <!--<c-table-entities striped caption="<i class='fa fa-align-justify'></i> Liste des entités"></c-table-entities>-->
          <div>
              <vue-good-table :columns="columns" styleClass="vgt-table condensed bordered striped" :row-style-class="rowStyleClassFn" :rows="rows" :fixed-header="false" :pagination-options="pagination" :search-options="search" :totalRows="totalRecords" mode="remote" @on-page-change="onPageChange" @on-per-page-change="onPerPageChange" @on-sort-change="onSortChange" @on-column-filter="onColumnFilter"> 
                <!--<vue-good-table :columns="columns" styleClass="vgt-table condensed" :rows="rows" :pagination-options="pagination" :search-options="search" :totalRows="totalRecords" mode="remote" @on-page-change="onPageChange" @on-per-page-change="onPerPageChange" @on-sort-change="onSortChange" @on-column-filter="onColumnFilter">-->
                 <template slot="table-row" slot-scope="props">
                    <span v-if="props.column.field == 'btn'" style="font-size: 0.875rem;">                        
                          <b-dropdown id="ddown-sm-split" size="sm" text="Plus de détails" class="m-2">
                            <div role="group" aria-lableledby="header1">  
                                <router-link :to="'edit/' + props.row.id" v-if="can('entite-edit')"><b-dropdown-item-button aria-describedby="header1" :id="props.row.id"><i class="fa fa-edit"></i> Modifier</b-dropdown-item-button></router-link>
                                <span v-if="props.formattedRow['active']=='activée'"><b-dropdown-item-button v-if="can('entite-delete')" @click.prevent="confirm(props.row.id)"><i class="fa fa-trash"></i> Désactiver</b-dropdown-item-button></span>            
                                <span v-if="props.formattedRow['active']=='désactivée'"><b-dropdown-item-button v-if="can('entite-delete')" @click.prevent="confirmA(props.row.id)"><i class="fa fa-trash"></i> Activer</b-dropdown-item-button></span>         
                                <router-link :to="'show/' + props.row.id" v-if="can('entite-list')"><b-dropdown-item-button aria-describedby="header1"><i class="fa fa-eye"></i> Plus d'infos</b-dropdown-item-button></router-link>
                            </div>
                            <div role="group" aria-lableledby="header2">
                              <b-dropdown-header id="header2">Autres actions ...</b-dropdown-header>   
                                <router-link :to="'/historique/entite/'+ props.row.id">
                                  <b-dropdown-item-button aria-describedby="header2"><i class="fa fa-users"></i> Historique des activités</b-dropdown-item-button>
                                </router-link>
                                <router-link :to="'/users/entite/list/'+ props.row.id" v-if="can('user-list-by-entite')">
                                  <b-dropdown-item-button aria-describedby="header2"><i class="fa fa-users"></i> Utilisateurs</b-dropdown-item-button>
                                </router-link>
                                <router-link :to="'/transferts/list/entity/'+ props.row.id" v-if="can('operation-list-by-entite')">
                                  <b-dropdown-item-button aria-describedby="header2"><i class="fa fa-money"></i> Opérations</b-dropdown-item-button>
                                </router-link>
                                <router-link :to="'/commisions_speciales/list/entite/'+ props.row.id" v-if="can('operation-list-by-entite')">
                                  <b-dropdown-item-button aria-describedby="header2"><i class="fa fa-money"></i> Commission Spéciales</b-dropdown-item-button>
                                </router-link>
                                <router-link :to="'/approvisionnements/entite/list/'+ props.row.id" v-if="can('approvisionnement-list-by-entite')">
                                  <b-dropdown-item-button aria-describedby="header2"><i class="fa fa-money"></i> Approvisionnement</b-dropdown-item-button>
                                </router-link>
                                <router-link :to="'/agences/list/entite/'+ props.row.id" v-if="can('agence-list-by-entite')">
                                  <b-dropdown-item-button aria-describedby="header2"><i class="fa fa-building"></i> Agences</b-dropdown-item-button>
                                </router-link>
                              <!--<b-dropdown-item-button aria-de
                              scribedby="header2">Delete</b-dropdown-item-button>-->
                            </div>
                          </b-dropdown>
                          <b-modal ref="myModalRef" hide-footer centered title="Confirmation de la désativation">
                            <div class="d-block text-center">
                              <p style>Etes vous certain de vouloir désactiver cette entité ?</p>
                              <h5>Voulez-vous continuer ?</h5>
                            </div>
                            <b-btn class="mt-3 col-lg-6" variant="outline-danger"  @click="cancel_delete" style="max-width: 100%;">Annuler</b-btn>
                            <b-btn class="mt-3 col-lg-6" variant="outline-success" style="max-width: 100%;" @click.prevent="desactiver()">Désactiver</b-btn>
                          </b-modal>
                          <b-modal ref="myModalRefA" hide-footer centered title="Confirmation de la désativation">
                            <div class="d-block text-center">
                              <p style>Etes vous certain de vouloir activer cette entité ?</p>
                              <h5>Voulez-vous continuer ?</h5>
                            </div>
                            <b-btn class="mt-3 col-lg-6" variant="outline-danger"  @click="cancel_deleteA" style="max-width: 100%;">Annuler</b-btn>
                            <b-btn class="mt-3 col-lg-6" variant="outline-success" style="max-width: 100%;" @click.prevent="activer()">Activer</b-btn>
                          </b-modal>
                        
                    </span>
                    <span style="font-size: 0.875rem;" v-else>
                      {{ props.formattedRow[props.column.field]}}
                    </span>
                  </template>  
              </vue-good-table>
              
          </div>
      </b-col><!--/.col-->
    </b-row><!--/.row-->
  </div>

</template>

<script>
//import cTableEntities from './TableEntities.vue'
import { VueGoodTable } from 'vue-good-table';
import { mapState, mapActions } from 'vuex';
export default {
  name: 'tables',
  //components: {cTableEntities},
  components: {VueGoodTable},
   data(){
    return {
      dismissSecs: 10,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      response:{},
      entity_id:'',
      totalRecords :0,
      columns: [
        {
          label: 'Gerant',
          field: 'gerant',
          width: '200px',
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter This Thing', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Email',
          field: 'email',
          type: 'email',
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter This Thing', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Nom',
          field: 'nom_commercial',
          width: '150px',
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter This Thing', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Solde',
          field: 'solde',
          type: 'number',
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter This Thing', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Téléphone',
          field: 'telephone',
          width: '150px',
         // type: 'percentage',
          filterable: true,
          thClass: 'custom-th-class',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter This Thing', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Type',
          field: 'typeentite_libelle',
          // type: 'percentage',
          filterable: true,
          thClass: 'custom-th-class',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter This Thing', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Statut',
          field: 'active',
          // type: 'percentage',
          filterable: true,
          thClass: 'custom-th-class',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter This Thing', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Créé le',
          field: 'created_at',
          type: 'date',
          width: '150px',
          dateInputFormat: 'YYYY-MM-dd',
          dateOutputFormat: 'YYYY-MM-dd',
          filterable: true,
          thClass: 'custom-th-class',
          formatFn: this.formatFn,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter This Thing', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Action',
          field: 'btn',
          html: true,
          width: '150px',
        }
      ],
      rows: [],
      pagination:{
        enabled: true,
        mode: 'pages',
        perPage: 10,
        position: 'bottom',
        perPageDropdown: [3,5, 10, 50,100],
        dropdownAllowAll: false,
        setCurrentPage: 1,
        nextLabel: 'Suivant',
        prevLabel: 'Précédent',
        rowsPerPageLabel: 'Lignes par page',
        ofLabel: 'de',
        pageLabel: 'page', // for 'pages' mode
        allLabel: 'All',
      },
      search:{
          enabled: false,
          trigger: 'keyup',
          placeholder: 'Rechercher dans la table',
      },
      serverParams: {
        gerant:'',
        email:'',
        nom_commercial:'',
        solde:'',
        telephone:'',
        typeentite_libelle:'',
        created_at:'',
        page:1,
        current_page: 1,
        nb_lines: 10
      }
    };
  },
  computed: mapState({
    entities: state => state.entity.all
  }),
  created () {
    // this.$store.dispatch('entity/get_all_entities').then(()=>{
    //     console.log('A')
    // })
  },
  methods:{
    rowStyleClassFn(row) {
      return row.active === 'désactivée' ? 'desactive' : '';
    },
    formatFn: function (value) {
        return value != null ? value : null
    },
    hideModal () {
      this.$refs.myModalRef.hide()
    },
    hideModalA () {
      this.$refs.myModalRefA.hide()
    },
    async cancel_delete(){
        this.hideModal()
    },
    async cancel_deleteA(){
        this.hideModalA()
    },
    showAlert () {
      this.dismissCountDown = this.dismissSecs
    },
    async confirm(id){
        this.entity_id = id
        this.$refs.myModalRef.show()
    },
    async confirmA(id){
        this.entity_id = id
        this.$refs.myModalRefA.show()
    },
    async desactiver(){
        console.log(this.entity_id)
        this.hideModal()
        this.response = await this.$store.dispatch('entity/delete_entites',this.entity_id)
        this.showAlert()
        this.loadItems()
    },
    async activer(){
        //console.log(this.entity_id)
        this.hideModalA()
        this.response = await this.$store.dispatch('entity/active_entites',this.entity_id)
        this.showAlert()
        this.loadItems()
    },
    async get_all_entities(){
        this.$store.dispatch('entity/get_all_entities').then(()=>{
            return this.rows = store.getters['entity/rows'];    
        })
    },
    can(perm){
        return store.getters['auth/can'](perm)
    },
    countDownChanged (dismissCountDown) {
        this.dismissCountDown = dismissCountDown
    },
    updateParams(newProps) {
        this.serverParams = Object.assign({}, this.serverParams, newProps);
      },
      onPageChange(params) {
        this.serverParams.page = params.currentPage
        this.updateParams({page: params.currentPage,current_page: params.currentPage});
        this.loadItems();
      },
      onPerPageChange(params) {
        this.serverParams.nb_lines = params.currentPerPage
        console.log(params)
        this.updateParams({page: params.currentPage,paginate:params.currentPerPage});
        this.loadItems();
      },
      onSortChange(params) {
        this.updateParams({
          sort: {
            type: params.sortType,
            field: this.columns[params.columnIndex].field,
          },
        });
        this.loadItems();
      },    
      onColumnFilter(params) {
        this.serverParams.gerant=params.columnFilters.gerant,
        this.serverParams.email=params.columnFilters.email,
        this.serverParams.nom_commercial=params.columnFilters.nom_commercial,
        this.serverParams.solde=params.columnFilters.solde,
        this.serverParams.telephone=params.columnFilters.telephone,
        this.serverParams.typeentite_libelle=params.columnFilters.typeentite_libelle,
        this.serverParams.created_at=params.columnFilters.created_at,
        // this.serverParams.created_at=params.columnFilters.created_at,
        this.updateParams(params);
        this.loadItems();
      },
      // load items is what brings back the rows from server
      loadItems() {
        this.$store.dispatch('entity/get_all_entities',this.serverParams).then((response)=>{
          this.totalRecords = response.total;
          return this.rows = store.getters['entity/rows'];
        })
      }
  },
  mounted(){
    //this.get_all_entities()
    this.loadItems()
  }
  
}
</script>
